/**
 * A work item's project, drawn the way every other list draws it.
 *
 * The command centre shows the same project on a card, a row, a detail panel
 * and a control list. Repeating `item.projectIcon ?? null` at each of them put
 * two decision points into four already-large components for one 14px glyph.
 */

import { ProjectIdentityIcon } from "../ProjectIdentityIcon";

export function WorkItemProjectIcon(props: {
  readonly projectName: string;
  readonly projectIcon?: string | null | undefined;
  readonly projectIconUrl?: string | null | undefined;
  readonly className?: string | undefined;
}) {
  return (
    <ProjectIdentityIcon
      className={props.className ?? "size-3.5"}
      icon={props.projectIcon ?? null}
      iconUrl={props.projectIconUrl ?? null}
      projectName={props.projectName}
    />
  );
}
